<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="deSelectMode" class="breadCrumb">
        Supplier data
      </v-btn>
      <v-btn @click="selectFieldData" class="breadCrumb" v-if="isFieldData">
        Field data
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" class="breadCrumb" v-if="isFieldData && isSupplierSelected">
        {{ currentSupplier.name }}
      </v-btn>
      <v-btn @click="selectProductionStatus" class="breadCrumb breadCrumbWide" v-if="isProductionStatus">
        Production status
      </v-btn>
      <v-btn @click="selectLabellingReports" class="breadCrumb breadCrumbWide" v-if="isLabellingReports">
        Labelling reports
      </v-btn>
      <v-btn @click="selectDailyProduction" class="breadCrumb breadCrumbWide" v-if="isDailyProduction">
        Daily production
      </v-btn>
      <v-btn @click="selectLoadingReport" class="breadCrumb breadCrumbWide" v-if="isLoadingReport">
        Loading report
      </v-btn>
      <v-btn @click="selectDeliveryReport" class="breadCrumb breadCrumbWide" v-if="isDeliveryReport">
        Delivery report
      </v-btn>
      <div style="display: inline; float: right;">
        <v-btn @click="$refs.forecast.printFieldData()" class="btnPrintReport" style="margin-right: 30px !important;" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">Print</v-btn>
        <v-btn @click="$refs.forecast.doNotShowAllFields()" class="btnToggleFilter" :disabled="!$refs.forecast.isShowingAllFields" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">Selected fields</v-btn>
        <v-btn @click="$refs.forecast.doShowAllFields()" class="btnToggleFilter" :disabled="$refs.forecast.isShowingAllFields" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">All fields</v-btn>

        <v-btn @click="productionStatusExcelReport" class="btnPrintReport" v-if="isProductionStatus && productionStatusLoaded">Excel</v-btn>
        <v-btn @click="dailyProductionPdfReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Print</v-btn>
        <v-btn @click="dailyProductionExcelReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Excel</v-btn>
        <v-btn @click="labellingReportExcelReport" class="btnPrintReport" v-if="isLabellingReports && labellingReportsLoaded">Excel</v-btn>

        <v-btn @click="loadingReportExcelReport" class="btnPrintReport" v-if="isLoadingReport && loadingReceiptsLoaded && isLoadingReportPallets">Excel</v-btn>
        <v-btn @click="selectLoadingReportModeShipments" class="btnToggleFilter" :disabled="isLoadingReportShipments" style="margin-left: 25px !important;" v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">Shipments</v-btn>
        <v-btn @click="selectLoadingReportModePallets" class="btnToggleFilter" :disabled="isLoadingReportPallets" v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">Pallets</v-btn>
        <v-btn @click="printDeliveryNote" class="close" style="margin-right: 25px !important;" v-if="showShipment">Print</v-btn>
        <v-btn @click="closeShipment" class="close" style="margin-right: 15px !important;" v-if="showShipment">Close</v-btn>

        <v-btn @click="deliveryReportPdfReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Print</v-btn>
        <v-btn @click="deliveryReportExcelReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Excel</v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-flex xs12 v-if="!isModeSelected">
      <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
        <v-btn @click="selectFieldData" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Field data</v-btn>
        <v-btn @click="selectProductionStatus" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Production status</v-btn>
        <v-btn @click="selectLabellingReports" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Labelling reports</v-btn>
        <v-btn @click="selectDailyProduction" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Daily production</v-btn>
        <v-btn @click="selectLoadingReport" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Loading report</v-btn>
        <v-btn @click="selectDeliveryReport" :style="'width: 100%; height: 10vh !important; font-size: 18pt !important; margin-bottom: 2vh !important;'">Delivery report</v-btn>
      </v-flex>
    </v-flex>

    <Forecast ref="forecast" hide-bread-crumb hide-buttons :edit-category-families="false" @supplierSelect="forecastSupplierSelected" v-if="isFieldData"/>

    <v-container fluid py-2 px-3 v-if="isProductionStatus && productionStatusLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionStatus">
            <tr>
              <th>Field</th>
              <th>Categories</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Labelled</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Planned</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Produced</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Progress</th>
            </tr>
            <tr v-for="(status, i) in productionStatus.fields" v-bind:key="status.field ? status.field.address.id : 0" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" v-if="status.field">
                <div v-if="status.field.address.name" style="font-weight: bold;">{{ status.field.address.name }}</div>
                {{ status.field.address.text }}
              </td>
              <td class="main" v-if="!status.field">
                &nbsp;
              </td>
              <td class="main">
                <table>
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.category.label }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.plannedAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.amount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount > 0 ? (Math.min(100, 100 * summary.amount / summary.labelledAmount).toFixed(0) + ' %') : 'N/A' }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLabellingReports && labellingReportsLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="labellingReports">
            <tr>
              <th>Category</th>
              <th>Supplier</th>
              <th>Field</th>
              <th style="text-align: right;">Amount</th>
            </tr>
            <tr v-for="(report, i) in labellingReports" v-bind:key="report.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main"><div v-if="report.category" v-html="report.category.label"></div></td>
              <td class="main"><div v-if="report.supplier" v-html="report.supplier.name"></div></td>
              <td class="main">
                <div v-if="report.field">{{ report.field.address && report.field.address.name && report.field.address.name !== '' ? report.field.address.name : report.field.address ? report.field.address.text : '' }}</div>
              </td>
              <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="report.total"></div></td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDailyProduction && dailyProductionLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionReport">
            <tr>
              <th>Produced</th>
              <th>By</th>
              <th>Shipment</th>
              <th>Pallet</th>
              <th>Category</th>
              <th style="text-align: right;">Amount</th>
              <th>Supplier</th>
              <th>Field</th>
            </tr>
            <template v-for="(report) in dailyProduction.dates">
              <tr v-for="(line) in report.lines" v-bind:key="line.key" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate') + (report.firstInRow && line.lineIndex === 0 ? ' dateChanged' : '')">
                <td class="main">{{ report.date !== '0000-00-00 00:00' && report.date !== '9999-12-31 23:59' ? report.date : '' }}</td>
                <td class="main">{{ line.producedBy ? line.producedBy : '' }}</td>
                <td class="main">{{ line.shipmentNumber }}</td>
                <td class="main">{{ line.palletNumber }}</td>
                <td class="main"><div v-html="line.categories"></div></td>
                <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="line.totalAmount"></div></td>
                <td class="main">{{ line.supplier.name }}</td>
                <td class="main">{{ line.field ? line.field.address && line.field.address.name && line.field.address.name !== '' ? line.field.address.name : line.field.address ? line.field.address.text : '' : ''}}</td>
              </tr>
            </template>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="loadingReceipts" v-if="isLoadingReportShipments">
            <tr>
              <th style="width: 150px;">Loaded</th>
              <th style="width: 150px;">Shipment</th>
              <th style="width: 150px;">License plate(s)</th>
              <th>Loading address</th>
              <th style="width: 150px;">Internal transport</th>
            </tr>
            <tr v-for="(shipmentLoaded, i) in shipmentsLoaded" v-bind:key="shipmentLoaded.shipment.id" @click="selectShipment(shipmentLoaded)" :class="'selectable ' + (i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" style="white-space: nowrap;">{{ shipmentLoaded.timestamp }}</td>
              <td class="main">{{ shipmentLoaded.shipment ? shipmentLoaded.shipment.number : '' }}</td>
              <td class="main" style="white-space: nowrap;">{{ shipmentLoaded.shipment ? shipmentLoaded.shipment.licensePlate : '' }}</td>
              <td class="main">{{ shipmentLoaded.address && shipmentLoaded.address.name && shipmentLoaded.address.name !== '' ? shipmentLoaded.address.name : shipmentLoaded.address ? shipmentLoaded.address.text : '' }}</td>
              <td class="main">{{ shipmentLoaded.internalTransport ? 'Yes' : 'No' }}</td>
            </tr>
          </table>
          <table class="loadingReceipts" v-if="isLoadingReportPallets">
            <tr>
              <th style="width: 150px;">Loaded</th>
              <th style="width: 50px;">By</th>
              <th style="width: 100px;">Pallet</th>
              <th>Supplier</th>
              <th>Shipment</th>
              <th>License plate(s)</th>
              <th>Category</th>
              <th style="width: 50px; padding-right: 20px;">Amount</th>
              <th>Loading address</th>
              <th style="width: 150px;">Internal transport</th>
            </tr>
            <tr v-for="(receipt, i) in loadingReceipts" v-bind:key="receipt.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" style="white-space: nowrap;">{{ receipt.timestamp }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.userFullName }}</td>
              <td class="main">{{ receipt.pallet.palletNumber }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.supplier.name }}</td>
              <td class="main">{{ receipt.shipment ? receipt.shipment.number : '' }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.shipment ? receipt.shipment.licensePlate : '' }}</td>
              <td class="main" style="white-space: nowrap;">
                <div v-for="(category, c) in receipt.categories" v-bind:key="c">{{ category }}</div>
              </td>
              <td class="main" style="text-align: right; white-space: nowrap; padding-right: 20px;">
                <div v-for="(amount, a) in receipt.amounts" v-bind:key="a">{{ amount }}</div>
              </td>
              <td class="main">{{ receipt.address && receipt.address.name && receipt.address.name !== '' ? receipt.address.name : receipt.address ? receipt.address.text : '' }}</td>
              <td class="main">{{ receipt.internalTransport ? 'Yes' : 'No' }}</td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-show="showShipment" class="shipmentContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <Panel :title="'Shipment #' + currentShipment.number" v-if="showShipment" class="shipmentPanel">
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              <v-label>Carrier</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.carrierName }}
            </v-flex>
            <v-flex xs12 sm4 v-if="!currentShipment.internalTransport"/>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              <v-label>Loading date</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.pickupDate }}
            </v-flex>
            <v-flex xs12 sm2>
              <v-label>License plate(s)</v-label>
            </v-flex>
            <v-flex xs12 sm4>
              {{ currentShipment.licensePlate }}
            </v-flex>
            <v-flex xs12 sm6 v-if="showShipmentComment">
              <div style="white-space: pre-wrap;">{{ currentShipment.comment }}</div>
            </v-flex>
            <v-flex xs12 style="height: 10px;"/>
            <v-flex xs12 v-if="palletOrders && palletOrders.length > 0" class="truckContainer" style="overflow-x: scroll;">
              <table style="min-width: 100%;">
                <tr style="height: 400px;">
                  <td>
                    <table class="palletPosition truck" v-if="showTruck">
                      <tr>
                        <td rowspan="4" class="front"></td>
                        <td colspan="5" style="height: 22px; background: transparent;"></td>
                      </tr>
                      <tr class="rightSide">
                        <LoaderPallet number="1" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-top-left-radius: 8px;"/>
                        <LoaderPallet number="3" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="5" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="7" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="9" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-top-right-radius: 8px;"/>
                      </tr>
                      <tr class="leftSide">
                        <LoaderPallet number="2" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-bottom-left-radius: 8px;"/>
                        <LoaderPallet number="4" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="6" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="8" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="10" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-bottom-right-radius: 8px;"/>
                      </tr>
                      <tr>
                        <td colspan="5" style="height: 22px; background: transparent;"></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </v-flex>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDeliveryReport && deliveryReportLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
          <v-data-table :headers="deliveryReportHeaders" :items="deliveryReport.items" hide-actions class="deliveryReportTable">
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left" style="width: 20px; padding-left: 8px !important; padding-right: 0 !important; padding-top: 4px !important; padding-bottom: 0 !important;">
                  <div v-if="props.item.category && props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                  <div v-if="props.item.category && props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                  <div v-if="!props.item.category">&nbsp;</div>
                </td>
                <td class="text-xs-left" style="padding-top: 4px !important;">
                  <div v-if="props.item.category">{{ props.item.category.displayLabel }}</div>
                  <div v-if="!props.item.category" style="font-weight: bold;">Total</div>
                </td>
                <td class="text-xs-right" style="padding-top: 4px !important;">
                  <div :style="props.item.category ? '' : 'font-weight: bold;'">{{ props.item.amount.toLocaleString() }}</div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PalletItems from '../components/PalletItems'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import Forecast from '../components/Forecast'
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'SupplierData',
  components: { Panel, LoaderPallet, PanelColumn, ErrorDialog, Forecast, PalletItems },
  data () {
    return {
      productionStatus: [],
      productionStatusLoaded: false,
      labellingReports: null,
      labellingReportsLoaded: false,
      loadingReceipts: null,
      loadingReceiptsLoaded: false,
      loadingReportMode: 'SHIPMENTS',
      currentShipment: null,
      palletOrders: [],
      pallets: [],
      palletPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      showTruck: false,
      dailyProduction: null,
      dailyProductionLoaded: false,
      deliveryReport: null,
      deliveryReportLoaded: false,
      mode: null,
      deliveryReportHeaders: [
        { text: '', sortable: false },
        { text: 'Category', value: 'category.displayLabel', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'right' }
      ],
      currentSupplier: null
    }
  },
  created: function () {
    this.deSelectMode()
  },
  computed: {
    hasForecastRole: function () {
      return this.$store.getters['session/hasRole']('FORECAST')
    },
    isSupplierSelected: function () {
      return this.currentSupplier
    },
    isModeSelected: function () {
      return this.mode !== null
    },
    isFieldData: function () {
      return this.mode === 'FIELD_DATA'
    },
    isProductionStatus: function () {
      return this.mode === 'PRODUCTION_STATUS'
    },
    isDailyProduction: function () {
      return this.mode === 'DAILY_PRODUCTION'
    },
    isLabellingReports: function () {
      return this.mode === 'LABELLING_REPORTS'
    },
    isLoadingReport: function () {
      return this.mode === 'LOADING_REPORT'
    },
    isLoadingReportShipments: function () {
      return this.loadingReportMode === 'SHIPMENTS'
    },
    isLoadingReportPallets: function () {
      return this.loadingReportMode === 'PALLETS'
    },
    isDeliveryReport: function () {
      return this.mode === 'DELIVERY_REPORT'
    },
    shipmentsLoaded: function () {
      let shipments = []
      if (this.loadingReceipts && this.loadingReceipts.length) {
        for (let loadingReceipt of this.loadingReceipts) {
          if (loadingReceipt.shipment && !shipments.filter(s => s.shipment.id === loadingReceipt.shipment.id).length) {
            let shipment = {
              timestamp: loadingReceipt.timestamp,
              shipment: loadingReceipt.shipment,
              address: loadingReceipt.address,
              internalTransport: loadingReceipt.internalTransport
            }
            shipments.push(shipment)
          }
        }
      }
      return shipments
    },
    showShipment: function () {
      return this.currentShipment !== null
    },
    showShipmentComment: function () {
      return this.currentShipment && this.currentShipment.comment
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    deSelectMode () {
      this.mode = null
      this.currentShipment = null
      this.showTruck = false
    },
    selectFieldData () {
      this.mode = 'FIELD_DATA'
      this.loadFieldData()
    },
    selectSupplier () {
      if (this.isFieldData) {
        this.$refs.forecast.selectSupplier(this.currentSupplier)
      }
    },
    selectProductionStatus () {
      this.mode = 'PRODUCTION_STATUS'
      this.loadProductionStatus()
    },
    selectDailyProduction () {
      this.mode = 'DAILY_PRODUCTION'
      this.loadDailyProduction()
    },
    selectLabellingReports () {
      this.mode = 'LABELLING_REPORTS'
      this.loadLabellingReports()
    },
    selectLoadingReport () {
      this.mode = 'LOADING_REPORT'
      this.currentShipment = null
      this.selectLoadingReportModeShipments()
      this.loadLoadingReceipts()
    },
    selectLoadingReportModeShipments () {
      this.loadingReportMode = 'SHIPMENTS'
    },
    selectLoadingReportModePallets () {
      this.loadingReportMode = 'PALLETS'
    },
    selectDeliveryReport () {
      this.mode = 'DELIVERY_REPORT'
      this.loadDeliveryReport()
    },
    loadFieldData () {
      this.currentSupplier = null
      this.$nextTick(() => {
        this.$refs.forecast.gotoForecast()
      })
    },
    loadProductionStatus () {
      this.productionStatus = []
      this.productionStatusLoaded = false
      axios.get('/backend/rest/production_status')
        .then(response => {
          this.productionStatus = response.data
          this.productionStatusLoaded = true
        })
    },
    loadDailyProduction () {
      this.dailyProductionLoaded = false
      axios.get('/backend/rest/production_report/supplier')
        .then(response => {
          this.dailyProduction = response.data
          this.dailyProductionLoaded = true
        })
    },
    loadLabellingReports () {
      this.labellingReportsLoaded = false
      axios.get('/backend/rest/label_report/supplier')
        .then(response => {
          this.labellingReports = response.data
          this.labellingReportsLoaded = true
        })
    },
    loadLoadingReceipts () {
      this.loadingReceiptsLoaded = false
      axios.get('/backend/rest/pallet_loading_receipt/supplier')
        .then(response => {
          this.loadingReceipts = response.data
          this.loadingReceiptsLoaded = true
        })
    },
    loadDeliveryReport () {
      this.deliveryReportLoaded = false
      axios.get('/backend/rest/delivery_report')
        .then(response => {
          this.deliveryReport = response.data
          if (this.deliveryReport && this.deliveryReport.items) {
            let total = 0
            for (let item of this.deliveryReport.items) {
              total += item.amount
            }
            this.deliveryReport.items.push({
              category: null,
              amount: total
            })
          }
          this.deliveryReportLoaded = true
        })
    },
    selectShipment: function (shipmentLoaded) {
      this.showTruck = true
      this.loadShipment(shipmentLoaded.shipment.id)
    },
    closeShipment: function () {
      this.currentShipment = null
    },
    printDeliveryNote: function () {
      let url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.currentShipment.id + '&details=true&title=Delivery Note'
      window.open(url)
    },
    loadShipment (shipmentId) {
      // console.log('Loading shipment')
      axios.get('/backend/rest/shipment/loader/' + shipmentId)
        .then(response => {
          this.currentShipment = response.data
          this.loadPalletsForShipment()
        })
    },
    loadPalletsForShipment () {
      this.palletOrders = []
      this.pallets = []
      this.palletPositions = [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ]
      if (this.currentShipment) {
        // console.log('Loading pallet orders for shipment ' + this.currentShipment.id)
        let url = '/backend/rest/pallet_order/shipment/' + this.currentShipment.id
        axios.get(url)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            this.palletOrders = response.data

            if (this.palletOrders && this.palletOrders.length > 0) {
              for (let palletOrder of this.palletOrders) {
                // console.log('Set pallet on position ' + (pallet.position - 1))
                this.$set(this.palletPositions, palletOrder.position - 1, palletOrder)
              }
            } else if (this.currentShipment.internalTransport) {
              this.palletOrders = []

              // Create dummy pallet orders
              for (let i = 0; i < 10; i++) {
                let palletOrder = {
                  id: -i - 1
                }
                this.palletOrders.push(palletOrder)
                this.$set(this.palletPositions, i, palletOrder)
              }
            }

            axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
              .then(response => {
                // console.log('Pallets: ' + JSON.stringify(response.data))
                this.pallets = response.data

                if (this.pallets && this.pallets.length > 0) {
                  for (let pallet of this.pallets) {
                    // console.log('Set pallet on position ' + (pallet.position - 1))
                    let position = this.currentShipment && pallet.internalTransportPosition ? pallet.internalTransportPosition : pallet.position
                    this.$set(this.palletPositions, position - 1, pallet)
                  }
                }
              })
          })
      }
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.plannedAmount + 'pcs.'
        }
      }
      return categories
    },
    productionStatusExcelReport () {
      let url = '/backend/report/supplierStatus&uuid=' + uuid()
      window.open(url)
    },
    dailyProductionPdfReport () {
      let url = '/backend/print/supplierProductionReportByDate.xhtml?uuid=' + uuid()
      window.open(url)
    },
    dailyProductionExcelReport () {
      let url = '/backend/report/productionReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    labellingReportExcelReport () {
      let url = '/backend/report/labelReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    loadingReportExcelReport () {
      let url = '/backend/report/loadingReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportPdfReport () {
      let url = '/backend/print/deliveryReport.xhtml?title=Delivery report&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportExcelReport () {
      let url = '/backend/report/deliveryReport&uuid=' + uuid()
      window.open(url)
    },
    forecastSupplierSelected (supplier) {
      // console.log('Forecast supplier selected: ', supplier)
      this.currentSupplier = supplier
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .v-btn .v-btn__content {
  }
  table.productionStatus {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionStatus th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionStatus td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.productionReport {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionReport th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionReport td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.labellingReports,
  table.loadingReceipts {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.labellingReports th,
  table.loadingReceipts th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.labellingReports td,
  table.loadingReceipts td {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.oddByDate {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenByDate {
    background-color: #ffffff;
  }
  tr.dateChanged {
    border-top: 2px solid #303030 !important;
  }
  .truckContainer {
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
  }
  .truck {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .truck tr td.front {
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    height: 400px;
    background-color: white;
    border: none;
    padding: 0;
    background-image: url('/static/truck.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
  }
  .truck tr td {
    background-color: #D0D0D0;
    border: none;
    padding: 3px;
  }
  .truck tr.rightSide td {
    padding-bottom: 2px !important;
  }
  .truck tr.leftSide td {
    padding-top: 2px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SupplierData.vue